import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d4856c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionSubmitView" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "bo" }, "浏览历史提交", -1))
const _hoisted_3 = { style: {"font-weight":"bolder"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { onMounted, onUnmounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRouter } from "vue-router";
import moment from "moment-timezone/moment-timezone-utils";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionSubmitView',
  setup(__props) {

const router = useRouter();
const store = useStore();
// console.log(store.state.user.loginUser.id);

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  userId: store.state.user.loginUser.id,
  current: 1,
  pageSize: 10,
  language: "",
  questionId: "",
  status: "",
});
const form = ref({
  ...searchParams.value,
});

/**
 * 加载数据
 */
const loadData = async () => {
  await MyAxios.post(
    "/question/question_submit/list/page",
    searchParams.value
  ).then((res) => {
    if (res.data.code === 0) {
      dataList.value = res.data.data.records;
      total.value = res.data.data.total;
      // console.log(res.data.data.records);
    } else {
      message.error("加载失败：" + res.data.message);
    }
  });
};

const statusFormat = (status: number) => {
  if (status == 0) {
    return "待判题";
  }
  if (status == 1) {
    return "判题中";
  }
  if (status == 2) {
    return "已完成";
  }
  if (status == 3) {
    return "判题失败";
  }
};
const timeFormat = (time: any) => {
  return moment(time).tz("Asia/Shanghai").format("YYYY-MM-DD hh:mm");
};
let interval: any;
onMounted(() => {
  loadData();
  interval = setInterval(loadData, 15000); // 每10秒加载一次新数据
});
onUnmounted(() => {
  clearInterval(interval); // 清除定时器以防内存泄漏
});
watchEffect(() => {
  loadData();
});

const changePageNum = (current: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: current,
  };
};
const changePageSize = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: pageSize,
  };
};
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    questionId: form.value.questionId,
    language: form.value.language,
    current: 1,
  };
};

const columns = [
  {
    title: "题号",
    dataIndex: "questionId",
  },
  {
    title: "编程语言",
    dataIndex: "language",
  },
  {
    title: "状态",
    slotName: "status",
  },
  {
    title: "结果",
    slotName: "message",
  },
  {
    title: "消耗时间",
    slotName: "time",
  },
  {
    title: "消耗内存",
    slotName: "memory",
  },
  {
    title: "创建时间",
    slotName: "createTime",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: form.value,
      layout: "inline",
      class: "bo"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { label: "题号" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.value.questionId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.questionId) = $event)),
              placeholder: "请输入题号",
              style: {"min-width":"240px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "编程语言" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              style: {"width":"160px","margin-bottom":"7px"},
              "trigger-props": { autoFitPopupMinWidth: true },
              modelValue: form.value.language,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.language) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("java")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("cpp")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("python")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: doSearch,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showPageSize: true,
        showJumper: true,
      },
      onPageChange: changePageNum,
      onPageSizeChange: changePageSize
    }, {
      judgeInfo: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.judgeInfo, (value, key) => {
                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                    _createElementVNode("td", _hoisted_3, _toDisplayString(key) + ":", 1),
                    _createElementVNode("td", null, _toDisplayString(value), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      message: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (record?.judgeInfo?.message == 'Accepted')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_a_tag, { color: "green" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record?.judgeInfo?.message), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : (record?.judgeInfo?.message == null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                    _createVNode(_component_a_tag, { color: "orange" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Waiting")
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _createVNode(_component_a_tag, { color: "red" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record?.judgeInfo?.message), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
          ]),
          _: 2
        }, 1024)
      ]),
      time: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record?.judgeInfo?.time) + " ms", 1)
          ]),
          _: 2
        }, 1024)
      ]),
      memory: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString((record?.judgeInfo?.memory / 1024).toFixed(2)) + " MB ", 1)
          ]),
          _: 2
        }, 1024)
      ]),
      status: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(statusFormat(record.status)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      createTime: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(timeFormat(record.createTime)), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"])
  ]))
}
}

})